import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AppNotification } from 'src/app/models/app-notification.model';

export const NotificationActions = createActionGroup({
  source: 'Notification',
  events: {
    'Load notifications': emptyProps(),
    'Show notification popup': props<{ notification: AppNotification }>(),
    'Notifications loaded': props<{ notifications: AppNotification[] }>(),
  },
});

export default NotificationActions;
